import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const WHATSAPP_NUMBER = "919560040097";

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  const [productName, setProductName] = useState("");
  const productMatch = pathname.match(/^\/products\/([^/]+)$/);

  useEffect(() => {
    setProductName("");
    if (productMatch) {
      api.get(`/products/${productMatch[1]}`)
        .then((r) => setProductName(r.data.name))
        .catch(() => {});
    }
  }, [pathname]);

  if (pathname.startsWith("/admin")) return null;

  const message = productName
    ? `Hello STJ Innovations, I am interested in your ${productName}. Please share specifications and a quotation.`
    : "Hello STJ Innovations, I have an enquiry about your cleanroom equipment and engineering solutions.";

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label={productName ? `Enquire about ${productName} on WhatsApp` : "Enquire on WhatsApp"}
      title="Enquire on WhatsApp"
      onClick={() => trackEvent("whatsapp_click", { location: "floating_button", product: productName || "general" })}
      className="fixed bottom-20 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-[#1FA855] text-white shadow-[0_8px_24px_rgba(8,21,36,0.25)] transition-transform duration-200 hover:scale-105 sm:bottom-6 sm:right-6"
    >
      <MessageCircle size={22} />
    </a>
  );
}
